import { useQuery, queryOptions } from '@tanstack/react-query';
import { useAccountStore } from '@/store/use-account-store';
import { privateApi } from '@/lib/api-clients/rest-client';
import { useUnifiedAccount } from '@/hooks';

type NonceResponse = {
  lastNonce: number;
};

export async function fetchNonce() {
  return privateApi
    .get<NonceResponse>('/account/nonce')
    .then((res) => res.lastNonce);
}

export const getNonceQueryOptions = () => {
  const { address, getAuthParams } = useAccountStore.getState();
  return queryOptions({
    queryKey: ['account/nonce', address, getAuthParams()?.signingKey], // temp: invalidate cache some other way?
    queryFn: () => fetchNonce(),
    refetchOnWindowFocus: true,
    staleTime: 10000,
  });
};
export default function useNonce() {
  const { address } = useUnifiedAccount();
  const { hasAuth, authParams } = useAccountStore((state) => ({
    hasAuth: state.hasAuth,
    authParams: state.getAuthParams(),
  }));

  const result = useQuery({
    enabled: hasAuth && !!address && !!authParams?.signingKey,
    ...getNonceQueryOptions(),
  });

  return result;
}
